<template>
	<div style="height: 100vh; display: flex; width: 100%;position: relative;overflow: hidden;background: #333;">
		<img style="position: absolute;width: 40%;height: auto;left: 50%;top:50%;transform: translate(-50%,-50%);" src="@/assets/bg.png"/>
		<div v-if="difference2 == '过期'" class="dqtx">
			<div>
				<p v-if="data.basics.expireFlag">您的软件已经过期{{ timeDifference ? timeDifference : "超过一周啦" }}</p>
				<p v-if="!data.basics.status&&!data.basics.expireFlag">您的软件已被禁用</p>
				<p>请及时联系您的业务员或拨打电话进行续费</p>
				<p>
					服务热线：
					<a href="13267110818">13267110818</a>
					
				</p>
			</div>
		</div>
		<FloatingWindow v-if="timeDifference" width="300px" height="85px">
			<p>中威软件温馨提示：</p>
			<p style="text-align: left">
				您的软件将在
				<a style="color: #ee4073">{{ timeDifference }}</a>
				后到期，请及时续费,以免影响您的正常使用！
			</p>
		</FloatingWindow>

		<div style="font-weight: bold; text-align: center; width: 100%;position: relative;background: rgba(51,51,51,0.5);color: #D9CA30;">
			<div style="font-size: 11vw; flex-shrink: 0;height: 50vh;display: flex;align-items: center;justify-content: center;padding-top: 10vh;">
				<span style="width: 50%;text-align: right;padding-right: 4vw;white-space: nowrap;">黄金回收</span>
				<span style="width: 50%;text-align: left;padding-left: 4vw;white-space: nowrap;">无需熔测</span>
			</div>
			<div style="display: flex;align-items: center;justify-content: center;height: 50vh;padding-bottom: 10vh;">
				<div style="position: relative;width: 50%;text-align: right;padding-right: 4vw;">
					<span style="font-size: 18vw">
						{{ (data.hqConter[0]&&data.hqConter[0].backPrice || 0).toString().split(".")[0] }}
					</span>
					<span style="font-size: 7vw">.{{ (data.hqConter[0]&&data.hqConter[0].backPrice || 0).toString().split(".")[1] || "00" }}</span>
					<span style="position: absolute; top: 8vw; font-size: 4vw; margin-left: -15%">元/克</span>
				</div>
				<span style="font-size: 11vw;width: 50%;text-align: left;padding-left: 4vw;white-space: nowrap;"> 免手续费</span>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import api from "@/api/http";
// import WaterMarks from "@/components/WaterMarks.vue";
import FloatingWindow from "@/components/FloatingWindow.vue";
// import notPage from "@/components/notPage.vue";
import useTimeDifference from "@/composables/useTimeDifference.js";
const { proxy } = getCurrentInstance();
const { timeDifference, difference2 } = useTimeDifference(); //判断本地时间和服务器时间
const data = ref({
	isMobile: false,
	color: "#000000",
	time: "",
	notPages: false,
	count: 0,
	tabbarHover: 0,
	hqConter: [],
	tenantId: "",
	basics: {}
});
let timerId2;
let timerId3;
const updateTime2 = () => {
	// 获取行情
	if (difference2.value == "过期") {
		clearInterval(timerId2);
		return;
	}
	const socket = new WebSocket(proxy.$globalConfig.wsURL);
	// 监听连接打开
	socket.addEventListener("open", () => {
		console.log("WebSocket连接成功");
		// 发送请求
		const requestData = { msgType: "url", data: data.value.tenantId };
		socket.send(JSON.stringify(requestData));
	});
	// 监听消息
	socket.addEventListener("message", event => {
		const response = JSON.parse(event.data);
		if (new Date(data.value.basics.usageTime[0]).getTime() > new Date().getTime()) {
			data.value.hqConter = [];
			data.value.jxConter = [];
			clearInterval(timerId2);
			clearInterval(timerId3);
			return;
		}
		if (response.length >= 1 && response[0].productName) {
			data.value.hqConter = response; // 处理响应数据
		}
		// 处理返回的消息数据
	});

	// 监听错误
	socket.addEventListener("error", error => {
		console.error("WebSocket连接错误:", error);
	});

	// 监听连接关闭
	socket.addEventListener("close", () => {
		console.log("WebSocket连接关闭,开始重连");
		data.value.hqConter = [];
		updateTime3();
	});
};
const updateTime3 = () => {
	//基础数据
	api.get("/metalMarket/sysTenantBoardConf/getByWebUrl/" + data.value.tenantId).then(response => {
		if (response.data) {
			updateTime2();
			// if (data.value.basics) {
			// 	if (data.value.basics.scaleFactor != response.data.scaleFactor) {
			// 		document.body.style.zoom = response.data.scaleFactor;
			// 		// document.html.style.transform = 'scale('+response.data.scaleFactor+')';
			// 	}
			// } else {
			// 	document.body.style.zoom = response.data.scaleFactor;
			// 	// document.html.style.transform = 'scale('+response.data.scaleFactor+')';
			// }
			data.value.basics = response.data; // 处理响应数据

			if (data.value.basics.expireFlag||!data.value.basics.status) {
				difference2.value = "过期";
				clearInterval(timerId2);
				clearInterval(timerId3);
			}
		} else {
			clearInterval(timerId3);
		}
	});
};

onMounted(async () => {
	// window.location.href = '/webSocketPage';
	// this.$router.push({ name: 'webSocketPage' });
	// const url = window.location.href.split("#")[0]; // 当前页面的URL
	const urlParams = new URLSearchParams(window.location.search);
	data.value.tenantId = urlParams.get("v");
	updateTime3();
	// timerId2 = setInterval(updateTime2, 1000);
	timerId3 = setInterval(updateTime3, 120000);
});
</script>
<script>
export default {
	name: "homeDP"
};
</script>
